import { Modal, Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';
import {
  saveAiAssistantProfile,
  setShowAiAssistant,
  updateAiAssistantProfileAttribute,
  updateAiAssistantUiAttribute
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { useEffect } from 'react';
import toast from 'react-hot-toast';

export const OwnIdentityModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  useEffect(() => {
    // check if the user has already set their own identity before => if so, don't show the modal
    if (profile.own_identity) {
      dispatch(
        updateAiAssistantUiAttribute({
          attribute: 'showOwnIdentityModal',
          value: false
        })
      );
    } else {
      dispatch(
        updateAiAssistantUiAttribute({
          attribute: 'showOwnIdentityModal',
          value: true
        })
      );
    }
  }, []);

  // Pull the relevant parts of your Redux state
  const {
    aiAssistant: {
      profile,
      ui: { showOwnIdentityModal }
    }
  } = useSelector((state: any) => state.lomavisCreator);

  // Handler to update Redux state when the user types
  const handleChange = (e) => {
    dispatch(
      updateAiAssistantProfileAttribute({
        attribute: 'own_identity',
        value: e.target.value
      })
    );
  };

  // Handler when user clicks Save
  const handleSave = () => {
    if (profile.own_identity.trim()) {
      dispatch(
        saveAiAssistantProfile(() => {
          // show toaster
          toast.success(t('lomavisCreator.aiAssistant.ownIdentitySaved'), {
            position: 'top-right'
          });
          dispatch(
            updateAiAssistantUiAttribute({
              attribute: 'showOwnIdentityModal',
              value: false
            })
          );
        }) as any
      );
    } else {
      toast.error(t('lomavisCreator.aiAssistant.ownIdentityRequired'), {
        position: 'top-right'
      });
    }
  };

  // Handler when user clicks Cancel
  const handleCancel = () => {
    dispatch(setShowAiAssistant(false));
  };

  return (
    <Modal
      show={showOwnIdentityModal}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>
          {t('lomavisCreator.aiAssistant.ownIdentityTitle')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="ownIdentityTextarea">
            <Form.Label>
              {t('lomavisCreator.aiAssistant.ownIdentityInstructions')}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={profile.own_identity || ''}
              onChange={handleChange}
              placeholder={t(
                'lomavisCreator.aiAssistant.ownIdentityPlaceholder'
              )}
              maxLength={500}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={handleCancel}>
          {t('lomavisCreator.aiAssistant.cancel')}
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={handleSave}
          disabled={!profile.own_identity?.trim()}
        >
          {t('lomavisCreator.aiAssistant.save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
